<template>
  <div v-if="locationFilter && locationFilter.locationTypes" class="ypo-event-location">
    <v-layout column wrap v-for="(locationType, idx) in locationFilter.locationTypes" :key="idx">
      <v-flex xs12 ml-3 class="filter-category">
        <label :class="['check-container', 'ypo_blue_color', idx === 1 ? 'check-container--no-margin-bottom' : '']">
          <v-layout>
            <v-flex class="check-container--label"
                    :data-qe-id="`location-facet_option-${idx}`">
              <span :class="[locationType.checked ? 'checked-option' : '']">{{locationType.label}}</span>
            </v-flex>
          </v-layout>
          <input type="checkbox"
                 :value="locationType"
                 v-model="localFilters"
                 @change="apply(locationType, locationType.filterValue)"
                 :data-qe-id="`location-facet_option-${idx}_input`">
          <span class="checkmark" :class="[locationType.checked ? 'checked-checkbox' : '']"></span>
        </label>
      </v-flex>
    </v-layout>
    <v-layout column v-if="locationFilter.countryList && locationFilter.countryList.length" pb-2>
      <v-flex xs12 ml-3>
        <v-select :items="locationFilter.countryList"
                  class="ypo-event-location__selections"
                  id="ypo-event-location_country"
                  item-text="label"
                  v-model="selectedCountry"
                  @change="handleCountrySelection()"
                  :disabled="!countryStateCityActive"
                  hide-details
                  attach
                  dense
                  return-object>
        </v-select>
      </v-flex>
      <v-flex xs12 v-if="locationFilter.stateList && locationFilter.stateList.length" ml-3>
        <v-select :items="locationFilter.stateList"
                  class="ypo-event-location__selections"
                  id="ypo-event-location_state"
                  item-text="label"
                  v-model="selectedState"
                  @change="handleStateSelection()"
                  hide-details
                  :disabled="!countryStateCityActive || locationFilter.stateList.length < 2"
                  attach
                  dense
                  return-object>
        </v-select>
      </v-flex>
      <v-flex xs12 v-if="locationFilter.cityList && locationFilter.cityList.length" ml-3>
        <v-select :items="locationFilter.cityList"
                  class="ypo-event-location__selections"
                  id="ypo-event-location_city"
                  item-text="label"
                  v-model="selectedCity"
                  @change="handleCitySelection()"
                  hide-details
                  :disabled="!countryStateCityActive || locationFilter.cityList.length < 2"
                  attach
                  dense
                  return-object>
        </v-select>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  getFilteredString,
  getUpdatedFiltersBasedOnLocation,
  ypoEventConstant,
} from "@/components/YpoEvents/ypoEvents.constant";
import {gaDataLayerEvent} from "@/plugins/analytics";
import {gtmEventName} from "@/plugins/gtmAnalytics";

export default {
  name: 'YpoEventsLocationFilter',
  props: {
    locationFilter: {
      type: Object,
      required: true,
    },
    appliedLocationFilters: {
      type: Array,
      required: true,
      default: () => [],
    },
    allAppliedFilters: {
      type: Object,
    },
    setMostRecentFacetInState: {
      type: Function,
      required: true,
    },
  },
  created() {
    this.setLocationFiltersState();
  },
  data() {
    return {
      ypoEventConstant,
      localFilters: [],
      selectedCountry: { ...ypoEventConstant.locationFilterDefaults.countryDefault },
      selectedState: { ...ypoEventConstant.locationFilterDefaults.stateDefault },
      selectedCity: { ...ypoEventConstant.locationFilterDefaults.cityDefault },
    };
  },
  methods: {
    setLocationFiltersState() {
      if (this.appliedLocationFilters && this.locationFilter) {
        this.selectedCountry = this.locationFilter.previouslySelectedCountry
            ? { ...this.locationFilter.previouslySelectedCountry }
            : { ...ypoEventConstant.locationFilterDefaults.countryDefault };

        this.selectedState = this.locationFilter.previouslySelectedState
            ? { ...this.locationFilter.previouslySelectedState }
            : { ...ypoEventConstant.locationFilterDefaults.stateDefault };

        this.selectedCity = this.locationFilter.previouslySelectedCity
            ? { ...this.locationFilter.previouslySelectedCity }
            : { ...ypoEventConstant.locationFilterDefaults.cityDefault };
      }
    },
    apply(filterItem, locationFilterKey) {
      const newEventFilters = getUpdatedFiltersBasedOnLocation(
          filterItem,
          this.appliedLocationFilters,
          this.allAppliedFilters,
          locationFilterKey,
      );
      if (this.setMostRecentFacetInState) this.setMostRecentFacetInState(ypoEventConstant.constant.keys.locationFilter);
      const gtmFilters = getFilteredString(newEventFilters) ;
      gaDataLayerEvent(gtmEventName.C_Event_Search_Filters, gtmFilters);

      this.$router.push({
        query: {
          ...this.$route.query,
          eventFilters: JSON.stringify(newEventFilters),
        },
      });
    },
    handleCountrySelection() {
      const { selectedCountry } = this;
      if (selectedCountry && selectedCountry.filterValue
          && this.appliedLocationFilters
          && !this.appliedLocationFilters.find(filter => filter.filterValue
                  && filter.filterValue.toLowerCase() === selectedCountry.filterValue.toLowerCase())) {

        const inPersonLocationFilterKey =
            selectedCountry.filterValue === ypoEventConstant.locationFilterDefaults.countryDefault.filterValue
                ? ypoEventConstant.locationFilterDefaults.countryDefault.filterValue
                : ypoEventConstant.constant.keys.countryState;

        this.apply(selectedCountry, inPersonLocationFilterKey);
      }
    },
    handleStateSelection() {
      const { selectedState } = this;
      if (selectedState && selectedState.filterValue
          && this.appliedLocationFilters
          && !this.appliedLocationFilters.find(filter => filter.filterValue
              && filter.filterValue.toLowerCase() === selectedState.filterValue.toLowerCase())) {
        const inPersonLocationFilterKey =
            selectedState.filterValue === ypoEventConstant.locationFilterDefaults.stateDefault.filterValue
                ? ypoEventConstant.locationFilterDefaults.stateDefault.filterValue
                : ypoEventConstant.constant.keys.countryState;

        const newEventFilters = getUpdatedFiltersBasedOnLocation(
            selectedState,
            this.appliedLocationFilters,
            this.allAppliedFilters,
            inPersonLocationFilterKey,
        );

        // adding selected Country back to the filter list
        newEventFilters[ypoEventConstant.constant.keys.locationFilter].push(this.selectedCountry);

        if (this.setMostRecentFacetInState) this.setMostRecentFacetInState(ypoEventConstant.constant.keys.locationFilter);
        this.$router.push({
          query: {
            ...this.$route.query,
            eventFilters: JSON.stringify(newEventFilters),
          },
        });
      }
    },
    handleCitySelection() {
      const { selectedCity } = this;
      if (selectedCity && selectedCity.filterValue
          && this.appliedLocationFilters
          && !this.appliedLocationFilters.find(filter => filter.filterValue
              && filter.filterValue.toLowerCase() === selectedCity.filterValue.toLowerCase())) {
        const inPersonLocationFilterKey =
            selectedCity.filterValue === ypoEventConstant.locationFilterDefaults.cityDefault.filterValue
                ? ypoEventConstant.locationFilterDefaults.cityDefault.filterValue
                : ypoEventConstant.constant.keys.countryStateCity;

        const city = selectedCity.filterValue.split('>').reverse();
        const cityDisplayLabel = `${city[0] || ''},
          ${city[1] && city[1] !== ypoEventConstant.constant.keys.noStateOrProvince ? `${city[1]},` : ''}
          ${city[2] || ''}`;

        const newCity = this.selectedCountry && this.selectedCountry.filterValue
            && this.selectedCountry.filterValue.toLowerCase() !== ypoEventConstant.locationFilterDefaults.countryDefault.filterValue.toLowerCase()
            ? { ...selectedCity, pillDisplayLabel: cityDisplayLabel }
            : { ...selectedCity };

        const newEventFilters = getUpdatedFiltersBasedOnLocation(
            newCity,
            this.appliedLocationFilters,
            this.allAppliedFilters,
            inPersonLocationFilterKey,
        );

        // adding any already selected Country
        if (this.selectedCountry &&
            this.selectedCountry.filterValue &&
            this.selectedCountry.filterValue !== ypoEventConstant.locationFilterDefaults.countryDefault.filterValue &&
            !this.appliedLocationFilters
                .find(item => item.filterValue
                    && item.filterValue.toLowerCase() === this.selectedCountry.filterValue.toLowerCase())) {
          newEventFilters[ypoEventConstant.constant.keys.locationFilter].push(this.selectedCountry);
        }

        // adding any already selected State
        if (this.selectedState &&
            this.selectedState.filterValue &&
            this.selectedState.filterValue !== ypoEventConstant.locationFilterDefaults.stateDefault.filterValue &&
            !this.appliedLocationFilters
                .find(item => item.filterValue
                    && item.filterValue.toLowerCase() === this.selectedState.filterValue.toLowerCase())) {
          newEventFilters[ypoEventConstant.constant.keys.locationFilter].push(this.selectedState);
        }

        if (this.setMostRecentFacetInState) this.setMostRecentFacetInState(ypoEventConstant.constant.keys.locationFilter);
        this.$router.push({
          query: {
            ...this.$route.query,
            eventFilters: JSON.stringify(newEventFilters),
          },
        });
      }
    },
  },
  computed: {
    inPersonActive() {
      let result = false;
      if (this.locationFilter && this.locationFilter.locationTypes) {
       const inPersonFilter = this.locationFilter.locationTypes
           .find(item => item.filterValue
               && item.filterValue.toLowerCase() === ypoEventConstant.constant.keys.inPersonLocationType.toLowerCase());
       result = !!(inPersonFilter && inPersonFilter.checked);
      }
      return result;
    },
    countryStateCityActive() {
      return this.appliedLocationFilters && this.appliedLocationFilters.length
          && !!(this.appliedLocationFilters
              .find(item => item.filterValue &&
                  item.filterValue.toLowerCase() === ypoEventConstant.constant.keys.inPersonLocationType.toLowerCase()));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';
@import '../../common/styles/_commonClasses.scss';

.ypo-event-location {
  .filter-category {
    @extend %ypo-secondary-checkbox;
  }

  .check-container--no-margin-bottom {
    margin-bottom: 0 !important;
  }

  &__selections {
    font-size: 12px !important;
    padding-top: 0;
    margin-top: 0;

    .v-select__selection {
      margin: 0 !important;
    }
  }
}

</style>
<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';
@import '../../common/styles/_commonClasses.scss';

.ypo-event-location {
  .v-select__selection--comma {
    margin-bottom: 0 !important;
    margin-left: 5px !important;
    text-transform: capitalize!important;
  }

  .theme--light.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before {
    border-image: none !important;
  }

  .v-select.v-text-field input {
    padding: 0 !important;
  }

  .v-menu__content {
    @extend %inner-scrollbar;
  }

  .v-list__tile {
    text-transform: capitalize;
  }

}
</style>
